import { PageProps, Script } from 'gatsby';
import React, { useEffect, useState } from 'react';

import { Box, Container, Stack, Typography } from '@mui/material';
import { AnalyticsPageType } from '@shopify/hydrogen-react';

import SeoHead from '../components/head';
import { HorizontalSlantContainer } from '../components/horizontal-slant-container';
import { useAnalytics } from '../shared/analytics';
import { headerSlantContainerNoContent } from '../shared/styles/headerSlantContainer';

export default function Review({ location }: PageProps) {
    // const theme = useTheme()
    // const isLargeMobile = useMediaQuery(theme.breakpoints.down("lg"))

    // const NotPrintable = styled('div')(notPrintable);
    const headerSlantContainerNoContentStyles = headerSlantContainerNoContent();

    const [productId, setProductId] = useState('')

    useEffect(() => {
        const searchParams = new URLSearchParams(location?.search);
        setProductId(searchParams.get('pid'))
    }, [location])

    const analytics = useAnalytics();
    useEffect(() => {
        analytics.trackPageView(AnalyticsPageType.page);
    }, [])

    return (
        <>
            <HorizontalSlantContainer id={"reviews"} autoHeight>
                <Container sx={headerSlantContainerNoContentStyles}></Container>
            </HorizontalSlantContainer>

            <Script>{`jdgm = window.jdgm || {};jdgm.SHOP_DOMAIN = '706fcd-3.myshopify.com';jdgm.PLATFORM = 'shopify';jdgm.PUBLIC_TOKEN = '5H59re9129AKLeB-8OUWqHnb81M';`}</Script><Script data-cfasync='false' type='text/javascript' async src='https://cdnwidget.judge.me/widget_preloader.js'></Script>

            <Container sx={{ pt: 6 }}>
                <Stack spacing={2}>
                    <Box>
                        <Typography variant="h1" gutterBottom>
                            Review your Bloo
                        </Typography>
                    </Box>

                    <div className="jdgm-widget jdgm-review-widget jdgm-outside-widget" data-id={productId}></div>
                </Stack>
            </Container>
        </>
    )
}
export const Head = (props: PageProps) => {

    return (
        <SeoHead
            title="Review"
            pathname={props.location.pathname}
            description="Review your Methylene Blue"
        />
    )
}
